import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import { Tabs } from 'antd-mobile'
import Baoyang from './baoyang';
import Weixiu from './weixiu';
import './index.less';

const PageModel = props => {
	const [id, setId] = useState('');
	const [object, setObject] = useState('');
	
	const getList = async () => {
		const result = await Request.get({
			url: '/dict/list'
		});
		if (!result) return;

		const list = result.data;
		console.log('list==',list);
		setObject(list);
	}
	useEffect(() => {
		console.log('保养');
		const { id } = props.match.params;
		console.log('传过来的;', id);
		if (id) {
			setId(id)
		}
		//获取数据字典
		getList()
	}, [123]);

	return (
		<Page {...{ page: 'upkeepdetail', showFooter: false, title: '设备保养' }} {...props}>
			<Tabs>
				<Tabs.Tab title='上报保养' key='0'>
					{object.baoyang && <Baoyang props={props} id={id} baoyang={object.baoyang} hscomp={object.hscomp}/>}
				</Tabs.Tab>
				<Tabs.Tab title='上报维修' key='1'>
					{object.weixiu && <Weixiu props={props} id={id} weixiu={object.weixiu} hscomp={object.hscomp} />}
				</Tabs.Tab>
			</Tabs>
		</Page>
	);
};

export default PageModel;
